module.exports = __webpack_public_path__ + "static/img/W_MINI_BAGS.e36f06d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/W_MINI_BAGS.jpg
// module id = hUrP
// module chunks = 1